import Vue from 'vue'
import Router from 'vue-router'
// import NotFound from '@/components/NotFound'
import Comment from '@/components/Comment'
import Result from '@/components/Result'
import Feedback from '@/components/Feedback'
import Pay from '@/components/Pay'
import Order from '@/components/Order'
import Index from '@/components/Index'
import Notify from '@/components/Notify'
import Form from '@/components/Form'
import GuoHuaQingZhengForm from '@/components/customs/GuoHuaQingZhengForm'
import Resultfit from '@/components/Resultfit'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/:innerCode/:productCode',
      name: 'Index',
      component: Index
    },
    {
      path: '/:innerCode/:productCode/notify',
      name: 'Notify',
      component: Notify
    },
    {
      path: '/:innerCode/:productCode/form',
      name: 'Form',
      component: Form
    },
    {
      path: '/:innerCode/:productCode/guohua-qingzheng-form',
      name: 'GuoHuaQingZhengForm',
      component: GuoHuaQingZhengForm
    },
    {
      path: '/:innerCode/:productCode/:unionCode/order',
      name: 'Order',
      component: Order
    },
    {
      path: '/:innerCode/:productCode/:unionCode/pay',
      name: 'Pay',
      component: Pay
    },
    {
      path: '/:innerCode/:productCode/:unionCode/feedback',
      name: 'Feedback',
      component: Feedback
    },
    {
      path: '/:innerCode/:productCode/:unionCode/result',
      name: 'Result',
      component: Result
    },
    {
      path: '/:innerCode/:productCode/:unionCode/resultfit',
      name: 'Resultfit',
      component: Resultfit
    },
    {
      path: '/:innerCode/:productCode/:unionCode/comment',
      name: 'Comment',
      component: Comment
    }
  ]
})

const _hmt = window._hmt

router.beforeEach((to, from, next) => {
  // window.sa.quick('autoTrackSinglePage')
  if (to.fullPath !== '/') {
    console.log('百度统计上报：/explosions/#' + to.fullPath)
    _hmt.push(['_trackPageview', '/explosions/#' + to.fullPath])
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js